import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'ngx-slider',
  styleUrls: ['./slider.component.scss'],
  templateUrl: './slider.component.html',
})
export class SliderComponent implements AfterViewInit {

  @Input() value;
  @Input() max = 1;
  @Input() min = 0;
  @Input() labelValue: (value) => {};

  @ViewChild('range') range;
  @ViewChild('label') label;

  scale = (num, in_min, in_max, out_min, out_max) => {
    return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
  };

  change() {
    // Get the width value of the input
    const range_width = getComputedStyle(this.range.nativeElement).getPropertyValue('width');
    // Get the width value of the label
    const label_width = getComputedStyle(this.label.nativeElement).getPropertyValue('width');
    // Remove 'px' and conver to number
    const num_width = +range_width.substring(0, range_width.length - 2);
    const num_label_width = +label_width.substring(0, label_width.length - 2);
    // Get min and max values
    const max = +this.range.nativeElement.max;
    const min = +this.range.nativeElement.min;
    // Calculate the left value
    const left = this.value * (num_width / max) - num_label_width / 2 + this.scale(this.value, min, max, 10, -10);
    this.label.nativeElement.style.left = `${left}px`;
    this.label.nativeElement.innerHTML = this.labelValue(this.value);
  }

  ngAfterViewInit() {
    this.change()

  }
}
